// Debug utility for Socket.IO and notification system
// Run this in the browser console to test notifications

import socketService from '../services/socketService';
import { getNotifications, getNotificationCount } from '../services/notificationService';

declare global {
  interface Window {
    debugSocketIO: () => void;
    testNotification: () => void;
    checkNotifications: (agencySlug: string) => void;
  }
}

export const debugSocketIO = () => {
  console.log('🔍 Socket.IO Debug Utility');
  console.log('Available functions:');
  console.log('- debugSocketIO(): Show this help');
  console.log('- testNotification(): Test real-time notification');
  console.log('- checkNotifications(agencySlug): Check existing notifications');
  console.log('');
  console.log('Socket.IO Status:', socketService.getConnectionState());
  console.log('Is Connected:', socketService.isSocketConnected());
};

export const testNotification = () => {
  console.log('🧪 Testing real-time notification...');
  
  // Listen for notifications
  const unsubscribe = socketService.onNotification((notification) => {
    console.log('✅ Received real-time notification:', notification);
    unsubscribe();
  });
  
  // Listen for count updates
  const unsubscribeCount = socketService.onNotificationCount((count) => {
    console.log('📊 Notification count updated:', count);
    unsubscribeCount();
  });
  
  console.log('👂 Listening for notifications...');
  console.log('💡 Create a reminder in the app to trigger a notification');
  console.log('💡 Or wait for scheduled notifications');
};

export const checkNotifications = async (agencySlug: string) => {
  console.log(`🔍 Checking notifications for agency: ${agencySlug}`);
  
  try {
    // Check notification count
    const countResponse = await getNotificationCount(agencySlug);
    console.log('📊 Current unread count:', countResponse.unreadCount);
    
    // Check recent notifications
    const notificationsResponse = await getNotifications(agencySlug, {}, 1, 5);
    console.log('📋 Recent notifications:', notificationsResponse.notifications);
    console.log('📄 Total notifications:', notificationsResponse.pagination.total);
    
  } catch (error) {
    console.error('❌ Error checking notifications:', error);
  }
};

// Make functions available globally for browser console access
if (typeof window !== 'undefined') {
  window.debugSocketIO = debugSocketIO;
  window.testNotification = testNotification;
  window.checkNotifications = checkNotifications;
}

export default {
  debugSocketIO,
  testNotification,
  checkNotifications
}; 